import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import type { ToastReportData } from '@/shared/model/briefing-resource.model';
import { LOADING_DATA_TYPE, REPORT_TOAST_STATUS, REPORT_TOAST_STATUS_CODE } from '@/constants';
import { namespace } from 'vuex-class';

const appStoreState = namespace('appStore');

@Component({
  computed: {
    LOADING_DATA_TYPE() {
      return LOADING_DATA_TYPE;
    },
    REPORT_TOAST_STATUS_CODE() {
      return REPORT_TOAST_STATUS_CODE;
    },
    REPORT_TOAST_STATUS() {
      return REPORT_TOAST_STATUS;
    },
  },
})
export default class ReportToastComponent extends Vue {
  @Prop(Object) readonly toastReportItem: ToastReportData | undefined;

  @Prop(Array) readonly reportTypesResult: string[];

  @Prop(Array) readonly reportTypesResultForBriefing: string[];

  @appStoreState.Getter
  public isShowCreateBriefing!: boolean;

  @appStoreState.Mutation
  public setShowCreateBriefing!: (payload: boolean) => void;

  handleRemoveToastReportDataByRequestId() {
    const button = document?.getElementById(this.toastReportItem && this.toastReportItem.requestId + '_buttonCloseToast');

    if (button) {
      button.click();
    }

    this.$emit('handleRemoveToastReportDataByRequestId', this.toastReportItem?.requestId || undefined);
  }

  handleOpenReportDetail() {
    this.setShowCreateBriefing(false);
    this.$emit('handleOpenReportDetail', this.toastReportItem?.notifyReportData || '', this.toastReportItem?.requestId || undefined);
  }

  handleGoToBriefingPage() {
    this.$emit('handleGoToBriefingPage', this.toastReportItem?.bpId || undefined, this.toastReportItem?.requestId || undefined);
  }

  handleGoToPage(page: string) {
    this.$emit('handleGoToPage', this.toastReportItem?.requestId || undefined, page);
  }

  get reportCreatingText(): string {
    if (['DAILY', 'DAILY_BLOG'].some(type => this.reportTypesResult.includes(type))) {
      return this.$t('cdToast.t4d') as string;
    } else if (this.reportTypesResult.includes('INDEPTH_DAILY')) {
      return this.$t('cdToast.t4a') as string;
    } else if (['PRODUCT_REVIEW', 'PRODUCT_REVIEW_BLOG'].some(type => this.reportTypesResult.includes(type))) {
      return this.$t('cdToast.t4b') as string;
    } else if (['INVESTMENT', 'INVESTMENT_BLOG'].some(type => this.reportTypesResult.includes(type))) {
      return this.$t('cdToast.t4c') as string;
    } else {
      return '';
    }
  }

  get generatedReportText(): string {
    if (['DAILY', 'DAILY_BLOG'].some(type => this.reportTypesResult.includes(type))) {
      return this.$t('cdToast.t16') as string;
    } else if (this.reportTypesResult.includes('INDEPTH_DAILY')) {
      return this.$t('cdToast.t16a') as string;
    } else if (['PRODUCT_REVIEW', 'PRODUCT_REVIEW_BLOG'].some(type => this.reportTypesResult.includes(type))) {
      return this.$t('cdToast.t16b') as string;
    } else if (['INVESTMENT', 'INVESTMENT_BLOG'].some(type => this.reportTypesResult.includes(type))) {
      return this.$t('cdToast.t16c') as string;
    } else {
      return '';
    }
  }

  get generateReportTitle(): string {
    if (['DAILY', 'DAILY_BLOG'].some(type => this.reportTypesResult.includes(type))) {
      return this.$t('toast-report.loading-toast.titleGeneral') as string;
    } else if (this.reportTypesResult.includes('INDEPTH_DAILY')) {
      return this.$t('toast-report.loading-toast.titleIn-depth') as string;
    } else if (['PRODUCT_REVIEW', 'PRODUCT_REVIEW_BLOG'].some(type => this.reportTypesResult.includes(type))) {
      return this.$t('toast-report.loading-toast.titleReview') as string;
    } else if (['INVESTMENT', 'INVESTMENT_BLOG'].some(type => this.reportTypesResult.includes(type))) {
      return this.$t('toast-report.loading-toast.titleInvestment') as string;
    } else if (
      ['SOCIAL_MEDIA', 'SOCIAL_MEDIA_FACEBOOK', 'SOCIAL_MEDIA_BLOG', 'SOCIAL_MEDIA_X', 'SOCIAL_MEDIA_YOUTUBE'].some(type =>
        this.reportTypesResult.includes(type)
      )
    ) {
      return this.$t('cdToast.t2') as string;
    } else if (['JOURNAL_NOTE', 'JOURNAL_NOTE_BLOG'].some(type => this.reportTypesResult.includes(type))) {
      return this.$t('cdToast.t1') as string;
    } else {
      return '';
    }
  }

  get briefingCreatingText(): string {
    if (['DAILY', 'DAILY_BLOG'].some(type => this.reportTypesResultForBriefing.includes(type))) {
      return this.$t('cdToast.t5') as string;
    } else if (this.reportTypesResultForBriefing.includes('INDEPTH_DAILY')) {
      return this.$t('cdToast.t5a') as string;
    } else if (['PRODUCT_REVIEW', 'PRODUCT_REVIEW_BLOG'].some(type => this.reportTypesResultForBriefing.includes(type))) {
      return this.$t('cdToast.t5b') as string;
    } else if (['INVESTMENT', 'INVESTMENT_BLOG'].some(type => this.reportTypesResultForBriefing.includes(type))) {
      return this.$t('cdToast.t5c') as string;
    } else {
      return '';
    }
  }

  get generatebriefingText(): string {
    if (['DAILY', 'DAILY_BLOG'].some(type => this.reportTypesResultForBriefing.includes(type))) {
      return this.$t('toast-report.loading-toast.infoText.textBriefingGeneral') as string;
    } else if (this.reportTypesResultForBriefing.includes('INDEPTH_DAILY')) {
      return this.$t('toast-report.loading-toast.infoText.textBriefingInDepth') as string;
    } else if (['PRODUCT_REVIEW', 'PRODUCT_REVIEW_BLOG'].some(type => this.reportTypesResultForBriefing.includes(type))) {
      return this.$t('toast-report.loading-toast.infoText.textBriefingReview') as string;
    } else if (['INVESTMENT', 'INVESTMENT_BLOG'].some(type => this.reportTypesResultForBriefing.includes(type))) {
      return this.$t('toast-report.loading-toast.infoText.textBriefingInvestment') as string;
    } else {
      return '';
    }
  }
}
